export default "__VITE_ASSET__eFFmtW75__"